module.exports = __webpack_public_path__ + "static/media/medx-protocol-logo@2x.6d65ba16.png";